export default {
  applyToVersions: "<2.6.0",
  type: "before",
  name: "rename 'games' store to 'simulations'",
  migrate(data) {
    if (!data.games) {
      return data;
    }

    // rename the store ('games' to 'simulations')
    const simulationStore = data.games;
    delete data.games;
    data.simulations = simulationStore;

    // change the item types
    for (const simulationId in simulationStore.items) {
      const simulation = simulationStore.items[simulationId];
      simulation.type = "simulation";
    }

    return data;
  }
};
